/**************************************** TYPE DEFINITIONS ****************************************/
export interface StoreSerialiationConfig {
    propsStored: any[];
    referenceProp: string;
}

/***************************************** CONFIG OBJECTS *****************************************/
/**
 * Symbols for storage on class
 */
const symbols = {
    TOTAL_INSTANCES: Symbol('TOTAL_INSTANCES'),
    CUR_INSTANCE_IDX: Symbol('CUR_INSTANCE_IDX'),
    STORE_OPTS: Symbol('STORE_OPTS'),
    KEEP_ON_LOGOUT: Symbol(`KEEP_ON_LOGOUT`),
    VAL_AFTER_LOGOUT: Symbol(`VAL_AFTER_LOGOUT`),
    SERIALIZER: Symbol(`SERIALIZER`),
    DESERIALIZER: Symbol(`DESERIALIZER`),
    PROPERTY_TYPE: Symbol(`PROPERTY_TYPE`),
    STORED_PROPS: Symbol(`STORED_PROPS`),
    REFERENCE_PROP: Symbol(`REFERENCE_PROP`),
    REF_PROP_VALUES: Symbol(`REF_PROP_VALUES`),
    NUM_UNINIT_STORES: Symbol(`NUM_UNINIT_STORES`),
};

const logWrapChar = '📦';

/**
 * Serialization log config
 */
const log = {
    initSeriNm: `initSerialization ::`,
    logWrapChar,
    tilde15: Array(15).join(logWrapChar),
};

/********************************************* EXPORT *********************************************/
export const serializationConfig = {symbols, log};
